// extracted by mini-css-extract-plugin
export default {"langSwitcher":"FormLayout_langSwitcher__duHIS"};